<template>
  <div id="app">
    <Headr></Headr>
    <router-view></router-view>
    <Footer></Footer>
  </div>
</template>

<script>
import Headr from "./components/Headr";
import Footer from "./components/footer";

export default {
  name: "App",
  components: { Footer, Headr },
};
</script>

<style lang="less">
#app {
  overflow-x: hidden;
  //min-height: 100vh;
  max-width: 1920px;
  margin: 0 auto;
}

.one-txt-line {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* 最多显示两行 */
.line-text--two {
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

/* 最多显示两行 */
.line-text--three {
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.many-txt-line {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.block_pagination {
  text-align: center;

  button {
    width: 32px !important;
    height: 32px !important;
    border: 1px solid #e5e5e5 !important;
    order-radius: 2px !important;
  }

  button:disabled {
    border: 1px solid #e5e5e5 !important;
  }

  input {
    border-radius: 2px;
  }

  .number {
    width: 32px !important;
    height: 32px !important;
    line-height: 32px !important;
    border: 1px solid #e5e5e5;
    border-radius: 2px;
    padding: 0;
  }

  .active {
    border-color: #00afef;
    background-color: #00afef !important;
  }

  .number:hover {
    color: #1a1a1a !important;
  }

  .active:hover {
    color: #ffffff !important;
  }

  .el-pager li.active + li {
    border-left: 1px solid #e5e5e5;
  }
  .block_pagination .el-pagination.is-background .el-pager .el-icon-more {
    border-left: none !important;
  }
}
</style>
